export default __webpack_public_path__ + "static/media/xplore.92d13390.jpg";